import React, { useCallback, useState } from 'react'
import styles from './SidebarFilter.module.less'
import { Flex } from 'antd'
import CloseIcon from '../../../assets/icons/close-icon.svg'
import SidebarFilter from './SidebarFilter'
import { SkillFilterDataRespType } from 'src/types/api.types'
import { FilteredTag } from 'src/hooks/useTag'
import { FilteredValueType } from 'src/types/expert.types'
import SearchBox from 'src/components/common/searchBox/SearchBox'
import { DataTestId, TextConstants } from 'src/constants/ui.constants'
import { debounce } from 'lodash'
import SegmentAnalytics from 'src/SegmentAnalytics'

const { SearchSkill, FilterBySkill } = TextConstants.SidebarPanel

export type SidebarProps = {
    toggleSidebarMenu: (val: boolean) => void
    updateTags: (newTag: FilteredTag) => void
    removedTagName: string
    removeTags: (key: string, value: string) => void
    skillsList: SkillFilterDataRespType[] | undefined
}

const SidebarPanel: React.FC<SidebarProps> = ({
    skillsList,
    toggleSidebarMenu,
    updateTags,
    removedTagName,
    removeTags,
}) => {
    const [listOfSkills, setListOfSkills] = useState<SkillFilterDataRespType[]>(skillsList || [])
    const [filteredValues, setFilteredValues] = useState<{ [key: string]: FilteredValueType }>({})

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const handleSearchEvent = useCallback(
        debounce((value: string) => {
            SegmentAnalytics.sendTrackEvent('FilterSection_Input_Text', {
                searchValue: value,
            })
        }, 1500),
        []
    )

    const handleSearch = useCallback(
        (value: string) => {
            const filteredSkills = (skillsList || []).filter(item =>
                item.filterLabel.toLowerCase().includes(value.toLowerCase().trim())
            )
            setListOfSkills(filteredSkills)
            value && handleSearchEvent(value)
        },
        [skillsList, handleSearchEvent]
    )

    return (
        <div data-testid={DataTestId.SidebarPanel}>
            <Flex vertical className={styles.sidebarHeader}>
                <Flex className={styles.heading}>
                    <span className={styles.title}>{FilterBySkill}</span>
                    <img
                        className={styles.icon}
                        data-testid={DataTestId.CloseIcon}
                        src={CloseIcon}
                        alt="Close Icon"
                        onClick={() => toggleSidebarMenu(true)}
                    />
                </Flex>
                <SearchBox placeholder={SearchSkill} onChange={handleSearch} />
            </Flex>
            <Flex vertical gap={'24px'} className={styles.filters}>
                {listOfSkills.map((filterData: SkillFilterDataRespType) => (
                    <SidebarFilter
                        key={filterData.id}
                        id={filterData.id}
                        filterLabel={filterData.filterLabel}
                        levelOptions={filterData.levelOptions}
                        skillValidatedOptions={filterData.skillValidatedOptions}
                        removedTagName={removedTagName}
                        updateTags={updateTags}
                        filteredValues={filteredValues}
                        setFilteredValues={setFilteredValues}
                        listOfSkills={listOfSkills}
                        removeTags={removeTags}
                    />
                ))}
            </Flex>
        </div>
    )
}

export default SidebarPanel
